import * as React from 'react';
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
export const Screen1 = () => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.desc}>
          <h1>Advance</h1>
          <p> — национальный лидер в разработке технологий эффективного обучения,<br />развития интеллекта и когнитивных (познавательных) навыков</p>
        </div>
        <div className={screen1.info}>
          <h2>Работаем со взрослыми и детьми от шести лет</h2>
          <ul>
            <li>Помогаем учиться в два раза быстрее и с удовольствием</li>
            <li>Даём не просто теорию, а умения и навыки</li>
            <li>Используем лучшие мировые практики и собственные, авторские технологии</li>
            <li>Наши курсы построены так, чтобы учащемуся было интересно не только за счёт игрофикации</li>
            <li>Постоянный рост результатов, расширение прежних возможностей и новые достижения — это естественный результат наших курсов и лучшая гарантия их прохождения</li>
          </ul>
        </div>
        <img src="https://fs.advance.ru/landing-pages/about/crew-bg-lp.png" alt="" className={screen1.imgTb}/>
        <img src="https://fs.advance.ru/landing-pages/about/crew-bg-mb.png" alt="" className={screen1.imgMb}/>
      </div>
    </section>
  );
};
